import React from 'react';
import ReactDOM from 'react-dom';
import Client from 'shopify-buy';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { CookiesProvider } from 'react-cookie';

const client = Client.buildClient({
  storefrontAccessToken: "28f23416cf09272d043ccdfc5dc3f32f",
  domain: 'andrewliuguavababa.myshopify.com'
});

ReactDOM.render(
  <CookiesProvider>
    <App client={client} />
  </CookiesProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
